
import React from 'react';
import { useSelector } from 'react-redux';
import { mergeStyleSets } from '@uifabric/merge-styles';

import LoginForm from '../../common/client/components/LoginForm';

const RootLogin = (props) => {

    const classNames = mergeStyleSets({
        root: {
            display: 'flex',
            flexDirection: 'column',
            flex: '1 0',
            alignItems: 'center'
        },
        panel: {
            backgroundColor: '#eeeeee',
            marginTop: '128px',
            padding: '8px',
            border: '1px solid #999999'
        },
        title: {
            fontSize: '32px'
        }
    });

    const loading = useSelector(state => {
        return state.auth.loading;
    });

    const projectId = useSelector(state => {
        return state.app.projectId;
    });

    if (loading) {
        return <div>Nahrávám...</div>
    } else {
        return (
            <div className={classNames.root}>
                <div className={classNames.panel}>
                    <div className={classNames.title}>Přihlášení</div>
                    <LoginForm projectId={projectId} />
                </div>
            </div>
        );
    }
}

export default RootLogin;
